"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MPEMidivalInput_lowerZone, _MPEMidivalInput_upperZone;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MPEMidivalInput = void 0;
const omnibus_1 = require("@hypersphere/omnibus");
const MPEInputZone_1 = require("./MPEInputZone");
/**
 * Defines MIDIVal MPE Input connection
 */
class MPEMidivalInput {
    constructor(input) {
        this.eventBus = new omnibus_1.Omnibus();
        _MPEMidivalInput_lowerZone.set(this, void 0);
        _MPEMidivalInput_upperZone.set(this, void 0);
        input.onMpeConfiguration(({ channel, msb }) => {
            if (channel === 1) {
                if (!msb) {
                    __classPrivateFieldSet(this, _MPEMidivalInput_lowerZone, null, "f");
                }
                else {
                    __classPrivateFieldSet(this, _MPEMidivalInput_lowerZone, new MPEInputZone_1.MPEInputZone(channel, [2, 1 + msb], input), "f");
                }
                this.eventBus.trigger("lowerZoneUpdate", __classPrivateFieldGet(this, _MPEMidivalInput_lowerZone, "f"));
            }
            if (channel === 16) {
                // Updating upper zone
                if (!msb) {
                    __classPrivateFieldSet(this, _MPEMidivalInput_upperZone, null, "f");
                }
                else {
                    __classPrivateFieldSet(this, _MPEMidivalInput_upperZone, new MPEInputZone_1.MPEInputZone(channel, [15 - msb, 15], input), "f");
                }
                this.eventBus.trigger("upperZoneUpdate", __classPrivateFieldGet(this, _MPEMidivalInput_upperZone, "f"));
            }
        });
    }
    get isMpeEnabled() {
        return __classPrivateFieldGet(this, _MPEMidivalInput_lowerZone, "f") !== null || __classPrivateFieldGet(this, _MPEMidivalInput_upperZone, "f") !== null;
    }
    get lowerZone() {
        return __classPrivateFieldGet(this, _MPEMidivalInput_lowerZone, "f");
    }
    get upperZone() {
        return __classPrivateFieldGet(this, _MPEMidivalInput_upperZone, "f");
    }
    onLowerZoneUpdate(cb) {
        return this.eventBus.on("lowerZoneUpdate", cb);
    }
    onUpperZoneUpdate(cb) {
        return this.eventBus.on("upperZoneUpdate", cb);
    }
}
exports.MPEMidivalInput = MPEMidivalInput;
_MPEMidivalInput_lowerZone = new WeakMap(), _MPEMidivalInput_upperZone = new WeakMap();
